// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { ClientsManagementSubscriptions } from '../../../../types/server/modules/clientsManagement/subscriptions';

export type * from '../../../../types/server/modules/clientsManagement/subscriptions';

export const createSubscriptions = ( requests: Requests ): ClientsManagementSubscriptions => ({
  AccountsReadmodel: ( params, onChange ) => {
          return requests.subscribe( `/accounts-readmodel/:id?`, params, 'AccountsReadmodel', onChange );
          },
  ClientsManagementConfigurationReadmodel: ( params, onChange ) => {
          return requests.subscribe( `/clients-management-configuration-readmodel/:id?`, params, 'ClientsManagementConfigurationReadmodel', onChange );
          },
  UsersProfilesMe: ( params, onChange ) => {
          return requests.subscribe( `/users-profiles/me`, params, 'UsersProfilesMe', onChange );
          },
  UsersProfiles: ( params, onChange ) => {
          return requests.subscribe( `/users-profiles/:id?`, params, 'UsersProfiles', onChange );
          },
  UserPreferences: ( params, onChange ) => {
          return requests.subscribe( `/user-preferences/:id?`, params, 'UserPreferences', onChange );
          },
  AssignmentGroupsReadmodel: ( params, onChange ) => {
          return requests.subscribe( `/assignment-groups-readmodel/:id?`, params, 'AssignmentGroupsReadmodel', onChange );
          }
});
